





























import { Component, Vue, Emit, Watch } from 'vue-property-decorator'
import { getModule } from 'vuex-module-decorators'
import BackofficeGlobalStore from '@/components/Backoffice/Store/BackofficeGlobalStore'
import { maskDate } from '@/utils/common'

@Component

export default class ComponentBackofficeOutrasSolicitacoesDoPaciente extends Vue {
  get getBackofficeGlobalStore() {
    return getModule(BackofficeGlobalStore, this.$store)
  }

  get headers() {
    return [
      { text: 'Procedimento principal', value: 'procedimentoPrincipalNome', sortable: false },
      { text: 'Médico solicitante', value: 'medicoNome', sortable: false },
      { text: 'Operadora', value: 'convenioNome', sortable: false },
      { text: 'Data confirmada', value: 'solicitacaoDataConfirmada', sortable: false },
      { text: 'Situação', value: 'situacao', sortable: false },
      { text: 'Reserva', value: 'solicitacaoNumeroAgendamento', sortable: false },
    ]
  }

  formatDate(date: string) {
    return maskDate(date)
  }
}
